import React from 'react';
import { Section, SectionTitle } from '../Section';
import { CTAButton } from '../CTAButton';
import { desireLines, forYouItems, painParagraphs } from '../../data/landing';
export function PainSection() {
  return <Section tone="wine" id="dolor" data-id="element-138" data-mp="1ss99izuaqwnt">
      <SectionTitle data-id="element-139" data-mp="1sp4xxhei4yn4">Nadie te enseñó a tocar.</SectionTitle>
      <div className="mt-10 space-y-6 text-[17px] leading-relaxed text-ivory/90 md:text-lg" data-id="element-140" data-mp="1nr3gf0wq57dr">
        {painParagraphs.map(p => <p key={p} data-id="element-141" data-mp="21q386hfja2e5">{p}</p>)}
      </div>
      <p className="mt-14 font-serif text-[2.4rem] italic leading-tight text-gold md:text-5xl" data-id="element-142" data-mp="1xqudnaco60hj">
        En 2 horas, eso cambia.
      </p>
    </Section>;
}
export function DesireSection() {
  return <Section tone="ink" className="text-center" data-id="element-143" data-mp="26icqpcebk06e">
      <SectionTitle data-id="element-144" data-mp="26kpi0g5yvmw4">Imagina saber exactamente qué hacer.</SectionTitle>
      <ul className="mt-10" data-id="element-145" data-mp="2lgopppp5zl0q">
        {desireLines.map((line, i) => <li key={line} className="flex flex-col items-center" data-id="element-146" data-mp="2ghc0iyatm1uz" data-mpi={i}>
            {i > 0 && <span aria-hidden="true" className="my-4 h-1.5 w-1.5 rotate-45 bg-gold/70" data-id="element-147" data-mp="1kpj4y1r3cegs" />}
            <p className="max-w-[520px] font-serif text-[1.45rem] leading-snug text-ivory md:text-[1.75rem]" data-id="element-148" data-mp="1krvw95iqo16i">{line}</p>
          </li>)}
      </ul>
      <div className="mt-12" data-id="element-149" data-mp="1tp69uxj142el">
        <CTAButton data-id="element-150" data-mp="1tsbwm646qs75" />
      </div>
    </Section>;
}
export function ForYouSection() {
  return <Section tone="wine" data-id="element-151" data-mp="1yqlpga2ftgpl">
      <SectionTitle data-id="element-152" data-mp="23oewf5bkeeqx">Esta clase es para ti si…</SectionTitle>
      <ul className="mt-12 space-y-6" data-id="element-153" data-mp="23nvn2czzcyoi">
        {forYouItems.map(item => <li key={item} className="flex gap-4 text-[17px] leading-relaxed text-ivory md:text-lg" data-id="element-154" data-mp="28mgi7y0dks63">
            <span aria-hidden="true" className="mt-[0.6em] h-2 w-2 shrink-0 rotate-45 bg-gold" data-id="element-155" data-mp="2df9ncmzra2ip" />
            <span data-id="element-156" data-mp="2heqqvavmgpl8">{item}</span>
          </li>)}
      </ul>
      <p className="mt-12 text-[15px] italic text-ivory/70" data-id="element-157" data-mp="2mf4zau14y1js">Sola, solo o en pareja. Para toda persona mayor de 18 años.</p>
    </Section>;
}